import { UserWalletActions, UserWalletActionType } from '@/store/wallet/actions';
import { BffApiErrorCode } from '@/models/bff-api-error';

export interface WalletModel {
  withdrawableBalance: number;
  currency: string;
  depositCount: number;
  balance: number;
  lifetimeDeposit: number | null;
  lastSuccessfulDeposit: number | null;
}

export interface WalletState {
  wallet: WalletModel;
  loading: boolean;
  error?: BffApiErrorCode;
}

const initialState: WalletState = {
  wallet: {
    withdrawableBalance: 0,
    currency: '',
    depositCount: 0,
    balance: 0,
    lifetimeDeposit: null,
    lastSuccessfulDeposit: null,
  },
  loading: false,
  error: undefined,
};

export const userWalletReducer = (state = initialState, action: UserWalletActions): WalletState => {
  switch (action.type) {
    case UserWalletActionType.GetUserWallet:
      return { ...state, loading: true, error: undefined };
    case UserWalletActionType.GetUserWalletError:
      return { ...state, ...initialState, loading: false, error: action.error };
    case UserWalletActionType.GetUserWalletSuccess: {
      return {
        ...state,
        wallet: action.wallet,
        loading: false,
        error: undefined,
      };
    }
    case UserWalletActionType.IncrementDepositCount:
      return { ...state, wallet: { ...state.wallet, depositCount: state.wallet.depositCount + 1 } };
    case UserWalletActionType.ResetUserWallet:
      return { ...initialState };
    default:
      return state;
  }
};
